import { Navigate, useRoutes } from "react-router-dom";
// auth
import AuthGuard from "../auth/AuthGuard";
import GuestGuard from "../auth/GuestGuard";
// layouts
import CompactLayout from "../layouts/compact";
import DashboardLayout from "../layouts/dashboard";
// config
import { PATH_AFTER_LOGIN } from "../config";
//
import {
    Page404,
    Home,
    Clone,
    Pilot,
    UserListPage,
    UserProfilePage,
    LoginPage,
    DataPage,
    FeedbackPage,
    LinksPage,
    ControlFlagPage,
} from "./elements";
import Backfill from "../pages/Backfill";
import SafeBackfill from "../pages/SafeBackfill";
import BulkEmailToUserId from "../pages/BulkEmailToUserId";
import AddToActivationDebug from "../pages/AddToActivationDebug";
import BetaGroup from "../pages/BetaGroup";
import AddToPilot from "../pages/AddToPilot";
import CheckIn from "../pages/CheckIn";

// ----------------------------------------------------------------------

export default function Router() {
    return useRoutes([
        {
            path: "/",
            children: [
                {
                    element: <Navigate to={PATH_AFTER_LOGIN} replace />,
                    index: true,
                },
                {
                    path: "login",
                    element: (
                        <GuestGuard>
                            <LoginPage />
                        </GuestGuard>
                    ),
                },
            ],
        },
        {
            path: "/dashboard",
            element: (
                <AuthGuard>
                    <DashboardLayout />
                </AuthGuard>
            ),
            children: [
                {
                    element: <Navigate to={PATH_AFTER_LOGIN} replace />,
                    index: true,
                },
                { path: "home", element: <Home /> },
                { path: "clone", element: <Clone /> },
                { path: "backfill", element: <Backfill /> },
                { path: "safe-backfill", element: <SafeBackfill /> },
                {
                    path: "user",
                    children: [
                        {
                            element: <UserListPage />,
                            index: true,
                        },
                        {
                            path: ":sub",
                            element: <UserProfilePage />,
                        },
                    ],
                },
                { path: "pilot", element: <Pilot /> },
                {
                    path: "data",
                    children: [
                        {
                            path: ":type",
                            element: <DataPage />,
                        },
                    ],
                },
                { path: "feedback", element: <FeedbackPage /> },
                { path: "links", element: <LinksPage /> },
                { path: "control-flags", element: <ControlFlagPage /> },
                {
                    path: "bulk-email-to-user-id",
                    element: <BulkEmailToUserId />,
                },
                {
                    path: "add-to-activation-debug",
                    element: <AddToActivationDebug />,
                },
                {
                    path: "beta-group",
                    element: <BetaGroup />,
                },
                {
                    path: "add-to-pilot",
                    element: <AddToPilot />,
                },
                {
                    path: "check-in",
                    element: <CheckIn />,
                },
            ],
        },
        {
            element: <CompactLayout />,
            children: [{ path: "404", element: <Page404 /> }],
        },
        { path: "*", element: <Navigate to="/404" replace /> },
    ]);
}
